import { Row, Space, Typography, Switch } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { SwitchPlansProps } from '@/types/plan';

const SwitchPlans: React.FC<SwitchPlansProps> = ({
  yearly,
  handleSwitch,
  percentage,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Row className="pad-switch">
      <Space align="center" size={8}>
        <Typography.Text
          className={yearly ? 'fs-14-regular' : 'fs-14-bold'}
          style={
            yearly
              ? { color: theme.colors.graySecondary }
              : { color: theme.colors.grayDarkPrimary }
          }
        >
          {t('organization.payments.plansModal.switchPlans.monthly')}
        </Typography.Text>

        <Switch
          checked={yearly}
          onChange={handleSwitch}
          aria-label="Switch between monthly and yearly plans"
        />
        <Typography.Text
          style={
            !yearly
              ? { color: theme.colors.graySecondary }
              : { color: theme.colors.grayDarkPrimary }
          }
          className={yearly ? 'fs-14-bold' : 'fs-14-regular'}
        >
          {t('organization.payments.plansModal.switchPlans.yearly')}
        </Typography.Text>
        {yearly && (
          <Typography.Text className=" fs-14 text-secondary-color">
            {t('organization.payments.plansModal.switchPlans.save')}{' '}
            {percentage}%!
          </Typography.Text>
        )}
      </Space>
    </Row>
  );
};

export default SwitchPlans;
